// extracted by mini-css-extract-plugin
module.exports = {"root":"_39lw_","CirclesMenuButtonSkin":"_3aY7p","circlesMenuButtonSkin":"_3aY7p","linkElement":"_2iv3r","bg":"_1zJi9"};